import { LeaseTypes } from '../models/Types';

/**
 * Special classname to prevent FullStory from capturing sensitive user information
 */
export const FULLSTORY_EXCLUDE = 'fs-exclude';
export const FULLSTORY_MASK = 'fs-mask';
export const FULLSTORY_UNMASK = 'fs-unmask';
export const FULLSTORY_IGNORE_RAGE_CLICKS = 'fs-ignore-rage-clicks';

export const ADDITIONAL_INFO = {
  IS_SELF_UPLOAD: {
    isSelfUpload: true,
  },
  IS_NOT_SELF_UPLOAD: {
    isSelfUpload: false,
  },
};

export enum LEASE_TYPES_ANALYTICS {
  ZILLOW_LEASE = 'ZillowLease',
  SELF_UPLOAD = 'SelfUpload',
  SIGNED_SELF_UPLOAD = 'SignedSelfUpload',
  UNKNOWN = 'Unknown',
}

export function determineTypeOfLease(leaseType: LeaseTypes): LEASE_TYPES_ANALYTICS {
  let typeOfLease;

  if (leaseType === LeaseTypes.SELF_UPLOAD) {
    typeOfLease = LEASE_TYPES_ANALYTICS.SELF_UPLOAD;
  } else if (leaseType === LeaseTypes.SIGNED_SELF_UPLOAD) {
    typeOfLease = LEASE_TYPES_ANALYTICS.SIGNED_SELF_UPLOAD;
  } else if (leaseType === LeaseTypes.ZILLOW_WIZARD) {
    typeOfLease = LEASE_TYPES_ANALYTICS.ZILLOW_LEASE;
  } else {
    typeOfLease = LEASE_TYPES_ANALYTICS.UNKNOWN; // Shouldn't happen
  }

  return typeOfLease;
}

export const ROLES = {
  COLANDLORD: 'colandlord',
  TENANT: 'tenant',
  LANDLORD: 'landlord',
};

export const TRACKING_KEYS = {
  LEASE_ID: 'leaseId',
  ROLE: 'role',
  LEASE_STATUS: 'leaseStatus',
  IS_SELF_UPLOAD: 'isSelfUpload',
};
